import * as React from 'react';
import { HeaderLogoAndTel } from '../../../HeaderLogoAndTel';

import * as main from '../styles/main.module.scss';
import * as screen1 from '../styles/screen1.module.scss';

export const Screen1 = ({ sravni }) => {
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel noLink={sravni} />
        <div className={screen1.screen1__info}>
          <h1 className={screen1.screen1__title}>Английский язык</h1>
          <p className={screen1.screen1__course}>Ускоренный курс обучения для любого уровня</p>
          <p className={screen1.screen1__instruments}>Как выучить английский за 3 месяца, рассказываем ниже!</p>
          <img
            src="https://fs.advance.ru/landing-pages/online/angliyskiy_dlya_vashih_celey/bg-adc-1920-new.png"
            alt={''}
          />
          <a className={`${screen1.screen1__button} ${main.allBtn}`} href={"#cost"}>
            Начать учиться
          </a>
        </div>
      </div>
    </header>
  );
}
